import dayjs from 'dayjs';
import type { DateTypeChecker } from './type';

export const dateTypeChecker: DateTypeChecker = {
  today: (date) => dayjs(date).isSame(dayjs(), 'day'),
  yesterday: (date) => dayjs(date).isSame(dayjs().subtract(1, 'day'), 'day'),
  sameYear: (date) => dayjs(date).isSame(dayjs(), 'year'),
  otherDay: () => true,
};
